const DeactivatedAccountGuard = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        zIndex: 99999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "90%",
          maxWidth: "420px",
          background: "#fff",
          borderRadius: "12px",
          padding: "28px",
          textAlign: "center",
          boxShadow: "0px 10px 30px rgba(0,0,0,0.25)",
        }}
      >
        <h3
          style={{
            color: "#d32f2f",
            marginBottom: "14px",
            fontWeight: "700",
          }}
        >
          Account Suspended
        </h3>

        <p
          style={{
            fontSize: "15px",
            color: "#555",
            lineHeight: "1.8",
            textAlign: "center",
            margin: 0,
          }}
        >
          Your account is suspended. You can only access limited profile
          settings.
          <br />
          For more information, check your email.
          <br />
          Or send us an email to{" "}
          <a
            href="mailto:hello@workcroft.com"
            style={{
              color: "#008bdc",
              textDecoration: "none",
              fontWeight: "600",
            }}
          >
            hello@workcroft.com
          </a>
          , stating the problem and issues.
        </p>

        <button
          onClick={onClose}
          style={{
            marginTop: "18px",
            background: "#d32f2f",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "10px 28px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default DeactivatedAccountGuard;
